<template>
    <div>
        <span>
            {{ cRouteName }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const cRouteName = computed(() => {
  const positions = params?.value?.data?.positions || []

  const positionNames = positions.map((item: any) => item.locationName)

  const name = positionNames.join(' >> ')
  return name
})
</script>
